import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeOutlinedCircledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.445 4.106c-2.334 0-3.112.777-3.112 3.11 0 2.217.702 3.03 2.773 3.106l1.895 2.339 1.894-2.34c2.07-.075 2.772-.888 2.772-3.104 0-2.334-.778-3.111-3.111-3.111zm1.08 3.888c0 .032.012.076.06.126.074.079.22.154.415.154a.57.57 0 0 0 .415-.154c.048-.05.06-.094.06-.126h.995c0 .32-.133.599-.33.808-.28.3-.7.468-1.14.468s-.86-.168-1.14-.468a1.18 1.18 0 0 1-.33-.808zm1.836-2.333c-.51 0-.68.34-.68.68s.17.681.68.681.68-.34.68-.68-.17-.68-.68-.68m-3.403.68c0-.34.17-.68.681-.68.51 0 .68.34.68.68s-.17.681-.68.681-.68-.34-.68-.68"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667m-4.807 3.06C2.283 4.818 1.867 6.345 1.867 8s.416 3.182 1.326 4.273c.878 1.054 2.346 1.86 4.807 1.86s3.93-.806 4.807-1.86c.91-1.091 1.326-2.618 1.326-4.273s-.416-3.182-1.326-4.273C11.93 2.673 10.461 1.867 8 1.867s-3.93.806-4.807 1.86"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CompanysLifeOutlinedCircledSize16Glyph.displayName = 'CompanysLifeOutlinedCircledSize16Glyph';
